import React from "react";

const SchemaNeurology = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What neurological conditions are treated at HDNA Aarogyam Hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam Hospital treats a wide range of neurological conditions including stroke, epilepsy, migraine, Parkinson’s disease, dementia, neuropathy, spinal cord injuries, nerve compression, brain tumors, and neuromuscular disorders."
        }
      },
      {
        "@type": "Question",
        "name": "Does HDNA Aarogyam Hospital provide emergency stroke care?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, the hospital has a dedicated Emergency Stroke Management Unit with 24x7 Neuro ICU support to provide rapid treatment within the golden hour, improving recovery outcomes."
        }
      },
      {
        "@type": "Question",
        "name": "What diagnostic tests are available for neurological disorders?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Neurology Department is equipped with advanced diagnostics such as EEG, EMG, MRI, CT Scan, and Nerve Conduction Studies for accurate diagnosis of brain and nerve conditions."
        }
      },
      {
        "@type": "Question",
        "name": "When should I consult a neurologist?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You should consult a neurologist if you experience persistent headaches, dizziness, seizures, memory loss, limb weakness, numbness, difficulty in speech, or walking problems."
        }
      },
      {
        "@type": "Question",
        "name": "Is neuro rehabilitation available after stroke or brain surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, HDNA Aarogyam Hospital offers comprehensive Neuro Rehabilitation Programs, including physiotherapy, speech therapy, occupational therapy, and cognitive training for post-stroke and post-surgery recovery."
        }
      },
      {
        "@type": "Question",
        "name": "Are both neurologists and neurosurgeons available at the hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, the hospital has a team of experienced neurologists and neurosurgeons who work together to provide complete medical and surgical care for neurological disorders."
        }
      },
      {
        "@type": "Question",
        "name": "How is epilepsy and seizure disorder managed at HDNA Aarogyam Hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Epilepsy is managed through accurate diagnosis using EEG, personalized medication plans, continuous monitoring, and long-term follow-up under expert neurologists."
        }
      },
      {
        "@type": "Question",
        "name": "Does the hospital treat spine and nerve-related problems?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, the Neurology Department specializes in treating spinal cord injuries, nerve compression, neuropathy, and chronic nerve pain using a multidisciplinary treatment approach."
        }
      },
      {
        "@type": "Question",
        "name": "What support services are provided for long-term neurological recovery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Patients receive holistic support including rehabilitation therapy, psychological counseling, lifestyle guidance, diet counseling for brain health, and regular follow-ups."
        }
      },
      {
        "@type": "Question",
        "name": "Why should I choose HDNA Aarogyam Hospital for neurology care in Bihar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam Hospital combines experienced neuro specialists, advanced diagnostics, 24x7 emergency care, and compassionate patient support, making it a trusted center for neurology care across Bihar."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaNeurology;
